//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

export function getAvailableTeamMembers(config?: AxiosRequestConfig | undefined): Promise<Types.SearchTeamMemberResultDto[]> {
    let url_ = getBaseUrl() + "/api/project-team";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetAvailableTeamMembers,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetAvailableTeamMembers?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetAvailableTeamMembers(_response);
    });
}

function processGetAvailableTeamMembers(response: AxiosResponse): Promise<Types.SearchTeamMemberResultDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
              result200 = resultData200.map(item => 
                Types.initSearchTeamMemberResultDto(item)
              );
            }
        return Promise.resolve<Types.SearchTeamMemberResultDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SearchTeamMemberResultDto[]>(null as any);
}

export function requestAccess(projectId: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/project-team/{projectId}/request-access";
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRequestAccess,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigRequestAccess?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRequestAccess(_response);
    });
}

function processRequestAccess(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigGetAvailableTeamMembers: Partial<AxiosRequestConfig> | null;
export function getGetAvailableTeamMembersRequestConfig() {
  return _requestConfigGetAvailableTeamMembers;
}
export function setGetAvailableTeamMembersRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetAvailableTeamMembers = value;
}
export function patchGetAvailableTeamMembersRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetAvailableTeamMembers = patch(_requestConfigGetAvailableTeamMembers ?? {});
}

let _requestConfigRequestAccess: Partial<AxiosRequestConfig> | null;
export function getRequestAccessRequestConfig() {
  return _requestConfigRequestAccess;
}
export function setRequestAccessRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRequestAccess = value;
}
export function patchRequestAccessRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRequestAccess = patch(_requestConfigRequestAccess ?? {});
}